export default __webpack_public_path__ + "static/img1-bdcd22d3b77b0121c8b7d9bb2de16d4e.png";